module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/experience03-dd4199de43ee139119988c1830d90387.svg";